// extracted by mini-css-extract-plugin
module.exports = {"subpage":"Subpage-module--subpage--2yuwg","subpage__title":"Subpage-module--subpage__title--3F_Hu"};